import { Button, Row } from '@tempmee/react';
import ClosePopupIcon from '../../images/ClosePopupIcon.svg';
import { Colors } from '../../themes/colors';

export const ConfirmPopupContent = ({
  rightButtonAction,
  leftButtonAction,
  rightButtonText,
  leftButtonText,
  title,
  titleStyle,
  description,
  descriptionStyle,
  Icon,
  closePopup,
  showClosePopupIcon,
  children,
  leftButtonStyle,
  rightButtonStyle,
  rightButtonDisabled,
  leftButtonDisabled,
  rightButtonLoading,
  closePopupDataCy,
  leftButtonDataCy,
  rightButtonDataCy,
}) => {
  const renderDescription = () => {
    if (!description) {
      return null;
    }

    if (typeof description === 'function') {
      const DescriptionComponent = description;
      return (
        <div
          style={{
            marginBottom: 70,
            ...descriptionStyle,
          }}
        >
          <DescriptionComponent />
        </div>
      );
    }

    return (
      <p
        style={{
          width: '80%',
          fontFamily: 'Nunito',
          fontSize: 16,
          color: Colors.neutral_500,
          textAlign: 'center',
          margin: 0,
          marginBottom: 70,
          ...descriptionStyle,
        }}
      >
        {description}
      </p>
    );
  };

  return (
    <>
      {showClosePopupIcon && (
        <img
          alt="close-popup-icon"
          src={ClosePopupIcon}
          data-cy={closePopupDataCy}
          data-testid="close-popup"
          style={{
            position: 'absolute',
            marginTop: -24,
            marginRight: 16,
            cursor: 'pointer',
            alignSelf: 'flex-end',
          }}
          onClick={closePopup}
        />
      )}

      {Icon && <Icon />}

      {title && (
        <h1
          style={{
            fontFamily: 'Nunito',
            fontWeight: 'bold',
            fontSize: 18,
            color: Colors.neutral_600,
            margin: 0,
            marginBottom: 20,
            textAlign: 'center',
            ...titleStyle,
          }}
        >
          {title}
        </h1>
      )}

      {renderDescription()}

      {children}

      <Row gap={4}>
        {leftButtonText && (
          <Button
            variant="secondary"
            data-cy={leftButtonDataCy}
            style={leftButtonStyle}
            onClick={leftButtonAction}
            disabled={leftButtonDisabled}
          >
            {leftButtonText}
          </Button>
        )}

        {rightButtonText && (
          <Button
            data-cy={rightButtonDataCy}
            data-testid="right-button"
            type="button"
            style={rightButtonStyle}
            onClick={rightButtonAction}
            disabled={rightButtonDisabled}
            isLoading={rightButtonLoading}
          >
            {rightButtonText}
          </Button>
        )}
      </Row>
    </>
  );
};
